import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=5fd582de&scoped=true&"
import script from "./Dialog.vue?vue&type=script&lang=js&"
export * from "./Dialog.vue?vue&type=script&lang=js&"
import style0 from "./Dialog.vue?vue&type=style&index=0&id=5fd582de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd582de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fd582de')) {
      api.createRecord('5fd582de', component.options)
    } else {
      api.reload('5fd582de', component.options)
    }
    module.hot.accept("./Dialog.vue?vue&type=template&id=5fd582de&scoped=true&", function () {
      api.rerender('5fd582de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/lib/components/ui/Dialog.vue"
export default component.exports